import React, { useState, useEffect } from "react"
import { useTranslation, withTranslation } from "next-i18next"
import _get from "lodash/get"
import { useDispatch } from "react-redux"
import {
  showToast,
  getGenericListPath,
} from "@/store/features/genericSlice"
import { getConfig } from "@/constants/config"
import LeadGenView from "./LeadGenView"

const LeadGen = props => {
  const { t } = useTranslation("common")
  const dispatch = useDispatch()
  const [ submitSuccess, setSubmitSuccess ] = useState(false)
  const [ brandName, setBrandName ] = useState("")
  const [ teaserComponent, setTeaserComponent ] = useState(null)

  useEffect(() => {
    getConfig().then(async config => {
      setBrandName(_get(config, "general.siteName", ""))
    })
    dispatch(getGenericListPath())
    if (document?.getElementById?.("aem-lead-gen-container")) {
      setTeaserComponent(document?.getElementById?.("aem-lead-gen-container"))
    }
  }, [])

  const i18n = {
    requiredInfoText: t("kf.auth.label.requiredFields"),
    fname: t("kf.contactus.label.firstName"),
    lname: t("kf.contactus.label.lastName"),
    email: t("kf.contactus.label.emailAddress"),
    state: t("kf.contactus.label.state"),
    zipcode: t("kf.contactus.label.zipCode"),
    country: t("kf.contactus.label.country"),
    successTitle:
      props?.data?.successtitle ?? t("kf.newsletter.label.getReady"),
    successDescription:
      props?.data?.successdescription ?? t("kf.contactus.label.messageSent"),
    startShopping:
      props?.data?.ctaLabel ?? t("kf.trademembership.label.startShopping"),
    fnameError: t("kf.contactus.error.fnameError"),
    lnameError: t("kf.contactus.error.lnameError"),
    noEmailError: t("kf.contactus.error.noEmailError"),
    validEmail: t("kf.contactus.error.validEmail"),
    stateError: t("kf.contactus.error.stateError"),
    zipcodeError: t("kf.contactus.error.zipcodeError"),
    validZipcode: t("kf.contactus.error.validZipcode"),
    serverError:
      props?.data?.errorMessage ?? t("kf.contactus.error.serverError"),
    occupation: t("kf.trademembership.label.occupation"),
    occupationError: t("kf.trademembership.error.occupation"),
    subscribe: t("kf.account.label.subscribe"),
    genError: t("kf.error.message.genericError"),
    alreadySubscribed: t("kf.newsletter.label.alreadySubscribed"),
  }
  const handleSubmit = status => {
    setSubmitSuccess(status)
  }
  const showToaster = msg => {
    dispatch(
      showToast({
        message: msg,
        isVisible: true,
      })
    )
  }
  return (
    <LeadGenView
      key={submitSuccess}
      i18n={i18n}
      submitSuccess={submitSuccess}
      handleSubmitMsg={handleSubmit}
      continueShoppingUrl={props?.data?.ctalink ?? ""}
      showToaster={msg => showToaster(msg)}
      brandName={brandName}
      isNewTab={props?.data?.isnewtab ?? false}
      teaserComponent={teaserComponent}
    />
  )
}

export default withTranslation()(LeadGen)
